import { Inset } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";
import ZVisionBanner from "./ZVisionBanner";
import ZVisionText from "./ZVisionText";

export default function Vision() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          <div className='col-lg-4'>
            <div className="container py-3">

              <div className='row pb-1'>
                <div className='col'>
                  <ZVisionBanner />
                </div>
              </div>

              <div className='row py-3'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-vision.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '40%',
                        height: '40%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>

            </div>
          </div>
           
          <div className='col-lg-8'>
            <ZVisionText />
          </div>
        </div>

      </div>
      
      <AddBottomSpace />
    </>
  )
}
